<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const props = defineProps<ToasterProps>()
const customizedClasses = [
	'!bottom-72px [font-family:inherit]',
	'[&_[data-sonner-toast]]:border-transparent [&_[data-sonner-toast]]:bg-n-950 [&_[data-sonner-toast]]:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)] [&_[data-sonner-toast]]:gap-16px mdp:[&_[data-sonner-toast]]:w-[350px]',
	'[&_[data-icon]]:h-24px [&_[data-icon]]:w-24px [&_[data-icon]]:m-0',
]
</script>

<template>
	<Sonner
		class="toaster group"
		:class="customizedClasses"
		v-bind="props"
		:toast-options="{
			classes: {
				title: 'text-white typography-b3-reg',
			},
		}"
	>
		<template #success-icon>
			<BaseIcon
				name="success_circle2_filled"
				class="h-24px w-24px fill-white"
			/>
		</template>
	</Sonner>
</template>
